import React from 'react';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';
import { Outlet } from 'react-router-dom';
export function Layout() {
  return <div className="min-h-screen bg-gray-50 flex" data-id="element-137">
      <Sidebar data-id="element-138" />
      <main className="flex-1 md:ml-64 min-h-screen pb-20 md:pb-0" data-id="element-139">
        <Outlet data-id="element-140" />
      </main>
      <MobileNav data-id="element-141" />
    </div>;
}